import React, { useEffect } from 'react'
import { Redirect, Switch, Route, HashRouter, BrowserRouter } from 'react-router-dom'
// Auth Routes
import Landing from '../pages/Auth/Landing/Landing'
import OTPVerify from '../pages/Auth/OTPVerify'
// import NewCustomer from '../pages/Auth/NewCustomer/NewCustomer'

//Landing Routes
import LandingExchangeRates from '../pages/Auth/Landing/ExchangeRates'
import LandingCalculator from '../pages/Auth/Landing/Calculator'

// Accounts Routes

import Requests from '../pages/Requests/Requests'
import Cheque from '../pages/Requests/Cheque/Cheque'
import ChequeBookRequest from '../pages/Requests/Cheque/ChequeBookRequest/ChequeBookRequest'
import StopChequePayment from '../pages/Requests/Cheque/StopChequePayment/StopChequePayment'
import ChequeStatus from '../pages/Requests/Cheque/ChequeStatus/ChequeStatus'
import ChequeBookStatus from '../pages/Requests/Cheque/ChequeBookStatus/ChequeBookStatus'
import Branch from '../pages/Branch/Branch'
import Calculator from '../pages/Calculator/Calculator'
import Profile from '../pages/Profile/Profile'
import Notifications from '../pages/Notifications/Notifications'
import Deposits from '../pages/Deposits/Deposits'
import Loans from '../pages/Loans/Loans'
import ApplyLoan from '../pages/Loans/ApplyLoan/ApplyLoan'
import Payments from '../pages/Payments/Payments'
import SendToMobile from '../pages/SendToMobile/SendToMobile'
import FAQ from '../pages/FAQ/FAQ'
import Suggestion from '../pages/Suggestion/Suggestion'
import DebitCard from '../pages/Requests/DebitCard/DebitCard'
import ChangeCardPIN from '../pages/Requests/DebitCard/ChangeCardPIN/ChangeCardPIN'
import CardLoad from '../pages/Requests/DebitCard/CardLoad/CardLoad'
import BlockDebitCard from '../pages/Requests/DebitCard/BlockDebitCard/BlockDebitCard'
import ViewStandingInstruction from '../pages/Requests/StandingInstruction/ViewStandingInstruction/ViewStandingInstruction'
import CreateStandingInstruction from '../pages/Requests/StandingInstruction/CreateStandingInstruction/CreateStandingInstruction'

import MyQRCode from '../pages/MyQRCode/MyQRCode'
import TermsAndConditions from '../pages/TermsAndConditions/TermsAndConditions'
import ExchangeRates from '../pages/ExchangeRates/ExchangeRates'
import ChangePassword from '../pages/Settings/ChangePassword/ChangePassword'
import CreateTermDeposits from '../pages/Deposits/TermDeposits/TermDeposits'
import ContactUs from '../pages/ContactUs/ContactUs'
import DownloadReceiptTransfer from '../pages/new-design/transfers/downloadReceipt'

import SchoolPayments from '../pages/School-Payments/school-payments'
import OtherPayments from '../pages/other-payments/other-payments'
import SetTargets from '../pages/Set-targets/set-targets'
import ServiceRequest from '../pages/ServiceRequest/ServiceRequest'
import ServiceRequestView from '../pages/ServiceRequest/ServiceRequestView'
import LinkAccount from '../pages/LinkAccount/LinkAccount'
import DeLinkAccount from '../pages/DeLinkAccount/DeLinkAccount'
import TopUpDeposits from '../pages/Deposits/TopUpDeposits/TopUpDeposits'
import RedeemDeposits from '../pages/Deposits/RedeemDeposits/RedeemDeposits'
import { LoanRepayment } from '../pages/Loans/loan-repayment/loan-repayment'
import AccountName from '../pages/Settings/AccountName/AccountName'
import VerifyLink from '../pages/AuthVerify/VerifyLink'
import Dashboard from '../pages/dashboard/dashboard'
import AccountStatement from '../pages/new-design/statement/statement'
import Accounts from '../pages/new-design/accounts/accounts'
import Transfers from '../pages/new-design/transfers/transfers'
import BeneficiaryOption from '../pages/new-design/transfers/beneficiary-options'
import BeneficiaryDownloadOption from '../pages/new-design/transfers/beneficiary-download-options'
import AddInternalBeneficiary from '../pages/new-design/transfers/beneficiary/add-intenal-beneficiary'
import AddDomesticBeneficiary from '../pages/new-design/transfers/beneficiary/add-domestic-beneficiary'
import AddInternationalBeneficiary from '../pages/new-design/transfers/beneficiary/add-international-beneficiary'
import BeneficiaryTransfer from '../pages/new-design/transfers/beneficiary/beneficiary-transfer'
import BeneficiaryView from '../pages/new-design/transfers/beneficiary/beneficiary-view'
import InternalAccountTransfer from '../pages/new-design/transfers/internal-transfer'
import Portfolio from '../pages/Portfolio/Portfolio'
import OtherAccountTransfer from '../pages/new-design/transfers/other-transfer'
import InternationalAccountTransfer from '../pages/new-design/transfers/international-transfer'
import QRCodePayment from '../pages/new-design/quickPay/QRCodePayment'
import SendToWallet from '../pages/new-design/quickPay/SendToWallet'
import AddNewAccount from '../pages/new-design/addAccount/add-new-account'
import DownLoadCenter from '../pages/new-design/download-center/download-center'
import SupportCenter from '../pages/new-design/support-center/support-center'
import AdditionalLinks from '../pages/new-design/additional-links/additional-links'
import OwnAccountTransfer from '../pages/new-design/transfers/own-account-transfer'
import AddBiller from '../pages/Payments/biller-list/add-biller'
import Login from '../pages/Auth/login'
import SignUp from '../pages/Auth/Signup/Signup'
import ForgotPassword from '../pages/Auth/ForgotPassword/ForgotPassword'
import LandingBranch from '../pages/Auth/Landing/Branch'
import EditInternalBeneficiary from '../pages/new-design/transfers/beneficiary/edit-internal-beneficiary'
import EditDomesticBeneficiary from '../pages/new-design/transfers/beneficiary/edit-domestic-beneficiary'
import EditInternationalBeneficiary from '../pages/new-design/transfers/beneficiary/edit-international-beneficiary'
import RepeatPayment from '../pages/new-design/transfers/repeat-payment'
import DetailedStatement from '../pages/new-design/statement/detailed-statement'
import Offers from '../pages/Offers/offers'
import AboutUs from '../pages/AboutUs/AboutUs'
import ForgotUsername from '../pages/Auth/ForgotUsername/forgot-username'
import TransferMT103 from '../pages/new-design/transfers/download-center/MT103'
// import TransferReciept from '../pages/new-design/transfers/download-center/reciepts'
import TransferBi from '../pages/new-design/transfers/download-center/biStatement'
import InvoicePayTemplate from '../pages/Auth/invoice-pay/invoice-template'
import CardLessCash from '../pages/CardLess-cash/cardLess-cash'
import GenerateToken from '../pages/CardLess-cash/generate-token'
import TransferViewScheduled from '../pages/new-design/transfers/download-center/viewScheduled'
import BIStatement from '../pages/BIStatement/biStatement'
import MT103 from '../pages/MT103/MT103'
import Receipts from '../pages/reciepts/reciepts'
import CurrentMonthStatement from '../pages/new-design/statement/current-month-stmt'
import LastThreeMonthStatement from './../pages/new-design/statement/last-three-month-stmt'
import CustomDatesStatement from './../pages/new-design/statement/custom-dates-stmt'
import LastTwoMonthStatement from './../pages/new-design/statement/last-two-month-stmt'
import Landing_ContactUs from '../pages/Auth/Landing/Contact-Us'
import BillerServicesView from '../pages/Payments/billers-services-view'
import BillerProduct from '../pages/Payments/billers-services-form'
import QuickPayServicesView from '../pages/new-design/quickPay/quick-pay-service-view'
import BillerProductForm from '../pages/new-design/quickPay/biller-product-form'
import BillerBeneList from '../pages/Payments/biller-list/biller-bene-list'
import PayBills from '../pages/Payments/payBills'
import DebitCardRequest from '../pages/Requests/DebitCard/CardRequest/cardRequest'
import QuickPay from '../pages/new-design/quickPay/QuickPay'
import InstantTransfer from '../pages/new-design/quickPay/InstantTransfer'
import PaymentsViewScheduled from '../pages/Payments/viewScheduledPayments'
import AddRegionalBeneficiary from './../pages/new-design/transfers/beneficiary/add-regional-beneficiary'
import RegionalTransfer from './../pages/new-design/transfers/regional-transfer'
import EditRegionalBeneficiary from './../pages/new-design/transfers/beneficiary/edit-regional-beneficiary'
import NewCustomer from '../pages/Auth/NewCustomer/NewCustomer'
import SchoolPayBillerProduct from '../pages/Payments/school-pay-form'
import Gimac from '../pages/new-design/gimac/gimac'
import GimacTransfer from '../pages/new-design/gimac/gimac-transfer'
import GimacPayment from '../pages/new-design/gimac/gimac-payment'
import GimacAtm from '../pages/new-design/gimac/gimac-atm'
import GimacReciepts from '../pages/new-design/gimac/gimac-reciepts'

export default function Router() {
  return (
    <BrowserRouter>
      <HashRouter>
        <Switch>
          <Route exact path='/auth/otp-verify'>
            <OTPVerify />
          </Route>
          <Route exact path='/login'>
            <Login />
          </Route>

          <Route exact path='/register'>
            <SignUp />
          </Route>

          <Route exact path='/forgot-password'>
            <ForgotPassword />
          </Route>

          <Route exact path='/forgot-username'>
            <ForgotUsername />
          </Route>

          <Route exact path='/landing'>
            <Landing />
          </Route>
          <Route exact path='/landing/exchangeRates'>
            <LandingExchangeRates />
          </Route>
          <Route exact path='/landing/calculator'>
            <LandingCalculator />
          </Route>
          <Route exact path='/landing/locateUs'>
            <LandingBranch />
          </Route>
          <Route exact path='/landing/contactUs'>
            <Landing_ContactUs />
          </Route>

          <Route
            exact
            path='/bankingservices/public/userRegistration/verifylink/:operation/:token/:userName'>
            <VerifyLink />
          </Route>
          <Route exact path='/dashboard'>
            <Dashboard />
          </Route>

          <Route exact path='/accounts'>
            <Accounts />
          </Route>

          {/* Account view statement */}
          <Route exact path='/statement'>
            <AccountStatement />
          </Route>

          <Route exact path='/detailed-statement'>
            <DetailedStatement />
          </Route>

          <Route exact path='/beneficiary-transfers/add-beneficiary'>
            <BeneficiaryOption />
          </Route>
          <Route exact path='/beneficiary-transfers/download-center'>
            <BeneficiaryDownloadOption />
          </Route>

          <Route exact path='/beneficiary-transfers/download-center/mt103'>
            <TransferMT103 />
          </Route>

          <Route exact path='/beneficiary-transfers/viewScheduled'>
            <TransferViewScheduled />
          </Route>

          <Route exact path='/beneficiary-transfers/download-center/bi'>
            <TransferBi />
          </Route>

          <Route exact path='/beneficiary-transfers/repeat-payment'>
            <RepeatPayment />
          </Route>
          <Route exact path='/beneficiary-transfers/view'>
            <BeneficiaryView />
          </Route>
          <Route exact path='/beneficiary-transfers/transfers'>
            <BeneficiaryTransfer />
          </Route>
          <Route exact path='/beneficiary-transfers/transfers/internal'>
            <InternalAccountTransfer />
          </Route>
          <Route exact path='/beneficiary-transfers/transfers/other'>
            <OtherAccountTransfer />
          </Route>
          <Route exact path='/beneficiary-transfers/transfers/international'>
            <InternationalAccountTransfer />
          </Route>

          <Route exact path='/beneficiary-transfers/transfers/own'>
            <OwnAccountTransfer />
          </Route>
          <Route exact path='/beneficiary-transfers/receipts'>
            <BeneficiaryOption />
          </Route>

          <Route exact path='/beneficiary-transfers/add-beneficiary/internal'>
            <AddInternalBeneficiary />
          </Route>

          <Route exact path='/beneficiary-transfers/edit-beneficiary/internal'>
            <EditInternalBeneficiary />
          </Route>
          <Route exact path='/beneficiary-transfers/edit-beneficiary/other'>
            <EditDomesticBeneficiary />
          </Route>
          <Route exact path='/beneficiary-transfers/edit-beneficiary/international'>
            <EditInternationalBeneficiary />
          </Route>

          <Route exact path='/beneficiary-transfers/add-beneficiary/domestic'>
            <AddDomesticBeneficiary />
          </Route>

          <Route exact path='/beneficiary-transfers/add-beneficiary/international'>
            <AddInternationalBeneficiary />
          </Route>

          <Route exact path='/beneficiary-transfers'>
            <Transfers />
          </Route>
          <Route exact path='/beneficiary-transfers/download-receipt'>
            <DownloadReceiptTransfer />
          </Route>

          {/* Requests */}
          <Route exact path='/requests/cheque/cheque-book-request'>
            <ChequeBookRequest />
          </Route>
          <Route exact path='/requests/cheque/stop-cheque-payment'>
            <StopChequePayment />
          </Route>
          <Route exact path='/requests/cheque/cheque-status'>
            <ChequeStatus />
          </Route>
          <Route exact path='/requests/cheque/chequeBook-status'>
            <ChequeBookStatus />
          </Route>
          <Route exact path='/requests/debitCard'>
            <DebitCard />
          </Route>
          <Route exact path='/requests/debitCard/cardRequest'>
            <DebitCardRequest />
          </Route>
          <Route exact path='/requests/debit-card/card-load'>
            <CardLoad />
          </Route>
          <Route exact path='/requests/debit-card/block-debit-card'>
            <BlockDebitCard />
          </Route>
          <Route exact path='/requests/standing-instruction/create'>
            <CreateStandingInstruction />
          </Route>
          <Route exact path='/requests/standing-instruction/view'>
            <ViewStandingInstruction />
          </Route>
          <Route exact path='/requests/debit-card'>
            <DebitCard />
          </Route>
          <Route exact path='/requests/standing-instruction'>
            <ViewStandingInstruction />
          </Route>
          <Route exact path='/requests/cheque'>
            <Cheque />
          </Route>
          <Route exact path='/requests'>
            <Requests />
          </Route>

          {/* Portfolio */}
          <Route exact path='/portfolio'>
            <Portfolio />
            {/* <Assets_Liabilities /> */}
          </Route>

          <Route exact path='/about-us'>
            <AboutUs />
          </Route>

          <Route path='/deposits/create-term-deposits'>
            <CreateTermDeposits />
          </Route>

          <Route path='/deposits/topup-deposits'>
            <TopUpDeposits />
          </Route>

          <Route path='/deposits/redeem-deposits'>
            <RedeemDeposits />
          </Route>
          <Route exact path='/deposits'>
            <Deposits />
          </Route>

          {/* Loans */}
          <Route exact path='/loans/apply'>
            <ApplyLoan />
          </Route>
          <Route exact path='/loans/repayment'>
            <LoanRepayment />
          </Route>
          <Route exact path='/loans'>
            <Loans />
          </Route>

          <Route exact path='/accounts/cardless-cash'>
            <CardLessCash />
          </Route>

          <Route exact path='/accounts/cardless-cash/generate'>
            <GenerateToken />
          </Route>

          <Route exact path='/payments'>
            <Payments />
          </Route>

          <Route exact path='/payments/add-biller'>
            <AddBiller />
          </Route>

          <Route path='/payments/biller-list'>
            <BillerBeneList />
          </Route>

          <Route path='/payments/payBills'>
            <PayBills />
          </Route>
          <Route exact path='/payments/servicesView'>
            <BillerServicesView />
          </Route>
          <Route exact path='/payments/services/product'>
            <BillerProduct />
          </Route>

          <Route exact path='/payments/services/school/product'>
            <SchoolPayBillerProduct />
          </Route>

          <Route exact path='/payments/viewScheduled'>
            <PaymentsViewScheduled />
          </Route>

          {/* Quick Pay */}
          <Route exact path='/beneficiary-transfers/quick-pay'>
            <QuickPay />
          </Route>
          <Route exact path='/beneficiary-transfers/quick-pay/instant-transfer'>
            <InstantTransfer />
          </Route>
          <Route exact path='/accounts/quick-pay'>
            <QuickPay />
          </Route>
          <Route exact path='/accounts/quick-pay/instant-transfer'>
            <InstantTransfer />
          </Route>
          <Route exact path='/beneficiary-transfers/quick-pay/serviceView'>
            <QuickPayServicesView />
          </Route>
          <Route exact path='/beneficiary-transfers/quick-pay/services/product'>
            <BillerProductForm />
          </Route>
          <Route exact path='/accounts/quick-pay/serviceView'>
            <QuickPayServicesView />
          </Route>
          <Route exact path='/accounts/quick-pay/services/product'>
            <BillerProductForm />
          </Route>
          <Route exact path='/quick-pay/qr'>
            <QRCodePayment />
          </Route>
          <Route exact path='/quick-pay/wallet'>
            <SendToWallet />
          </Route>

          {/* Send To Mobile */}
          <Route exact path='/send-to-mobile'>
            <SendToMobile />
          </Route>

          {/* Branch */}
          <Route exact path='/set-targets'>
            <SetTargets />
          </Route>

          {/* Branch */}
          <Route exact path='/branch'>
            <Branch />
          </Route>

          {/* My QR Code */}
          <Route exact path='/qr-code'>
            <MyQRCode />
          </Route>

          {/* Add Account */}
          <Route exact path='/add-account'>
            {/* <AddAccount /> */}
            <AddNewAccount />
          </Route>

          {/* Link Account */}
          <Route exact path='/link-account'>
            <LinkAccount />
          </Route>

          {/* DeLink Account */}
          <Route exact path='/deLink-account'>
            <DeLinkAccount />
          </Route>

          {/* School Payments */}
          <Route exact path='/schoolPayments'>
            <SchoolPayments />
          </Route>

          {/* Other Payments */}
          <Route exact path='/otherPayments'>
            <OtherPayments />
          </Route>

          {/* Contact Us */}
          <Route exact path='/contact-us'>
            <ContactUs />
          </Route>

          {/* Terms and Conditions */}
          <Route exact path='/terms-and-conditions'>
            <TermsAndConditions />
          </Route>

          {/* Calculator */}
          <Route exact path='/calculator'>
            <Calculator />
          </Route>

          <Route exact path='/offers'>
            <Offers />
          </Route>

          {/* Settings */}
          <Route exact path='/change-password'>
            <ChangePassword />
          </Route>
          <Route exact path='/add-accountName'>
            <AccountName />
          </Route>

          {/* Exchange Rates */}
          <Route exact path='/exchange-rate'>
            <ExchangeRates />
          </Route>

          {/* Profile */}
          <Route exact path='/profile'>
            <Profile />
          </Route>

          {/* Notifications */}
          <Route exact path='/notifications'>
            <Notifications />
          </Route>

          {/* FAQ */}
          <Route exact path='/faq'>
            <FAQ />
          </Route>

          {/* Suggestion */}
          <Route exact path='/suggestion'>
            <Suggestion />
          </Route>

          {/* Service Request */}
          <Route exact path='/serviceRequest'>
            <ServiceRequest />
          </Route>

          {/* Service Request View */}
          <Route exact path='/serviceRequestView'>
            <ServiceRequestView />
          </Route>

          {/* Receipts */}
          <Route path='/receipts'>
            <Receipts />
          </Route>

          <Route path='/mt103'>
            <MT103 />
          </Route>
          <Route exact path='/biStatement'>
            <BIStatement />
          </Route>
          <Route exact path='/download-center'>
            <DownLoadCenter />
          </Route>
          <Route exact path='/support-center'>
            <SupportCenter />
          </Route>
          <Route exact path='/additional-links'>
            <AdditionalLinks />
          </Route>

          <Route exact path='/currentMonth'>
            <CurrentMonthStatement />
          </Route>
          <Route exact path='/lastTwoMonth'>
            <LastTwoMonthStatement />
          </Route>
          <Route exact path='/lastThreeMonth'>
            <LastThreeMonthStatement />
          </Route>
          <Route exact path='/customDates'>
            <CustomDatesStatement />
          </Route>

          <Route exact path='/beneficiary-transfers/add-beneficiary/regional'>
            <AddRegionalBeneficiary />
          </Route>

          <Route exact path='/beneficiary-transfers/transfers/regional'>
            <RegionalTransfer />
          </Route>

          <Route exact path='/beneficiary-transfers/edit-beneficiary/regional'>
            <EditRegionalBeneficiary />
          </Route>

          <Route exact path='/wallet-customer'>
            <NewCustomer />
          </Route>

          <Route exact path='/gimac-pay'>
            <Gimac />
          </Route>

          <Route exact path='/gimac-pay/transfer'>
            <GimacTransfer />
          </Route>

          <Route exact path='/gimac-pay/payment'>
            <GimacPayment />
          </Route>

          <Route exact path='/gimac-pay/atm'>
            <GimacAtm />
          </Route>

          <Route exact path='/gimac-pay/reciepts'>
            <GimacReciepts />
          </Route>

          <Redirect exact from='/' to='/landing' />
          <Redirect exact from='/auth' to='/login' />
        </Switch>
      </HashRouter>
    </BrowserRouter>
  )
}
